/**
 * result-versions.js — JS-ЗЕРКАЛО единого резолвера версий результата.
 *
 * Питон-оригинал: utils/result_versions.py. Держать В СИНХРОНЕ: те же
 * цепочки приоритетов, тот же порядок. Изменил порядок в Python → поправь
 * здесь (и наоборот).
 *
 * ЗАЧЕМ (аудит 2026-07-20): выбор версии дублировался в 6+ местах
 * (chat-доставка, модерация, Mini App грид/viewer/download, Next) с
 * расходящимися цепочками. Mini App вдобавок НЕ имел CDN-fallback (падал
 * при потере локального файла) и игнорировал result_png_url (терял
 * прозрачность при скачивании). Этот модуль — единый источник правды
 * на фронте Mini App.
 *
 * Версии IMAGE (media v53.0):
 *   result_png_url    native lossless PNG — только alpha (bg-removal)
 *   local_image_url   native WebP q95 (== preview_url, один файл)
 *   preview_url       то же что local_image_url
 *   thumbnail_url     800px q90 WebP (фоновая задача, может быть NULL)
 *   result_image_url  FAL CDN URL (или NULL для base64)
 *
 * Грузится EAGER (index.html, до lazy-bundle my-generations/image-viewer),
 * чтобы window.ResultVersions существовал к моменту рендера карточек.
 */
(function (global) {
    'use strict';

    function first() {
        for (var i = 0; i < arguments.length; i++) {
            if (arguments[i]) return arguments[i];
        }
        return null;
    }

    var RV = {
        /** Полноэкранный просмотр / источник inline-фото: native → CDN. */
        imageDisplay: function (g) {
            g = g || {};
            return first(g.local_image_url, g.preview_url, g.thumbnail_url, g.result_image_url);
        },

        /** Скачивание: максимум качества + честная прозрачность (PNG для alpha). */
        imageDownload: function (g) {
            g = g || {};
            return first(g.result_png_url, g.local_image_url, g.preview_url, g.result_image_url);
        },

        /** Грид: лёгкий thumbnail с полной цепочкой отката (вкл. CDN). */
        imageGridThumb: function (g) {
            g = g || {};
            return first(g.thumbnail_url, g.preview_url, g.local_image_url, g.result_image_url);
        },

        /** Полный mp4: локальный → CDN. */
        videoFull: function (g) {
            g = g || {};
            return first(g.local_image_url, g.result_video_url);
        },

        /** Poster-кадр видео. */
        videoPoster: function (g) {
            g = g || {};
            return first(g.preview_url, g.thumbnail_url);
        },

        /** Tiny autoplay-клип → полный mp4 как резерв. */
        videoGridClip: function (g) {
            g = g || {};
            return first(g.result_video_preview_url, g.result_video_url);
        },

        /**
         * Упорядоченный список fallback-версий для onerror-цепочки в гриде.
         * &lt;img onerror&gt; перебирает их по очереди, пока какая-то не загрузится
         * (раньше битый thumbnail оставлял пустой тайл без отката).
         */
        imageFallbackChain: function (g) {
            g = g || {};
            var chain = [g.thumbnail_url, g.preview_url, g.local_image_url, g.result_image_url];
            var seen = {}, out = [];
            for (var i = 0; i < chain.length; i++) {
                var u = chain[i];
                if (u && !seen[u]) { seen[u] = 1; out.push(u); }
            }
            return out;
        },
    };

    global.ResultVersions = RV;

    /**
     * onerror-хендлер для &lt;img&gt; в гриде: при провале загрузки берёт
     * следующую версию из data-fallbacks (JSON-массив, порядок =
     * imageFallbackChain). Раньше битый thumbnail оставлял пустой тайл
     * без отката на preview/CDN.
     *
     * Использование в шаблоне:
     *   &lt;img src="${chain[0]}" data-fallbacks='${json}'
     *        onerror="window.__genImgFallback&amp;&amp;window.__genImgFallback(this)"&gt;
     */
    global.__genImgFallback = function (img) {
        try {
            var list = JSON.parse(img.getAttribute('data-fallbacks') || '[]');
            // data-fb-i: индекс СЛЕДУЮЩЕЙ версии (0 уже показан как исходный src).
            var i = parseInt(img.getAttribute('data-fb-i') || '1', 10);
            if (i < list.length) {
                img.setAttribute('data-fb-i', String(i + 1));
                img.src = list[i];
            } else {
                img.onerror = null; // цепочка исчерпана — прекращаем (нет зацикливания)
            }
        } catch (e) {
            img.onerror = null;
        }
    };
})(window);
